import { SidebarMenuButton, SidebarSeparator, useSidebar } from "@altimateai/lego";
import { isFreeStack, isSSOEnabled } from "@/helpers/tenant";
import { ChatWithUs } from "@/pages/home/ChatWithUs";
import { handleReadmeClick } from "@/pages/home/helper";
import { cn } from "@/lib/utils";
import { IconBellRinging, IconFileText } from "@tabler/icons-react";
import { InviteBox } from "./InviteBox";
import { Stack } from "@altimateai/lego";
import { isAdmin, isOwner } from "@/services/auth";

export const SidebarFooter = () => {
  const { open } = useSidebar();
  const isFreeUser = isFreeStack();

  return (
    <Stack gap={"sm"} direction={"column"}>
      {!isSSOEnabled() && (isAdmin() || isOwner()) && <InviteBox />}
      {isFreeUser ? (
        <>
          <ChatWithUs />
        </>
      ) : (
        <>
          <SidebarSeparator className={"!al-mx-0"} />
          <ChatWithUs />
          <SidebarMenuButton
            onClick={e => handleReadmeClick(e, "release")}
            className={cn("[&>svg]:al-size-5 al-text-muted-foreground", open ? "al-p-3" : "")}
          >
            <IconBellRinging />
            <span className="group-data-[state=collapsed]:al-hidden">Release Notes</span>
          </SidebarMenuButton>
          <SidebarMenuButton
            onClick={e => handleReadmeClick(e, "documentation")}
            className={cn("[&>svg]:al-size-5 al-text-muted-foreground", open ? "al-p-3" : "")}
          >
            <IconFileText />
            <span className="group-data-[state=collapsed]:al-hidden">Documentation</span>
          </SidebarMenuButton>
        </>
      )}
    </Stack>
  );
};
